import Header from "./components/Header";
import AccountSection from "./components/AccountSection";
import InputWrapper from "../components/InputWrapper";
import GoBack from "../components/GoBack";
import PasswordRequirements from "../../components/PasswordRequirements";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import AppContext from "../../../context";
import Data from "../Data";
import Meta from "../../components/Meta";

const ChangePassword = () => {
    const context = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();

    const submit = async (data) => {
        if (data.newPassword !== data.confirmPassword) {
            setError("New passwords do not match.");
            return;
        }
        setLoading(true);
        setError(null);

        try {
            await Data.changePassword(context.user.email, data.currentPassword, data.newPassword);
            setSuccess(true);
            reset();
        } catch (err) {
            setError(err?.response?.data?.message || "An error occurred. Please check your current password and try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Meta title={"Change Password"} />
            <GoBack to={"/account"} label={"Back to My Account"} />
            <Header heading={"Change Password"} />
            <div className={"container mx-auto p-6 pt-0"}>
                <AccountSection>
                    {success ? (
                        <p className={"text-green-600"}>Your password has been updated successfully.</p>
                    ) : (
                        <form className={"grid grid-cols-1 gap-4 max-w-md"} onSubmit={handleSubmit(submit)}>
                            <InputWrapper label={"Current Password"} input={
                                <input type={"password"} {...register("currentPassword", { required: true })} />
                            } error={errors.currentPassword ? "This field is required" : null} />

                            <InputWrapper label={"New Password"} input={
                                <>
                                    <input type={"password"} {...register("newPassword", { required: true })} />
                                    <PasswordRequirements password={watch("newPassword") || ""} />
                                </>
                            } error={errors.newPassword ? "This field is required" : null} />

                            <InputWrapper label={"Confirm New Password"} input={
                                <input type={"password"} {...register("confirmPassword", { required: true })} />
                            } error={errors.confirmPassword ? "This field is required" : null} />

                            {error && <p className={"text-red-500 text-sm"}>{error}</p>}

                            <button
                                type={"submit"}
                                disabled={loading}
                                className={"bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md border-0"}
                            >
                                {loading ? "Updating..." : "Update Password"}
                            </button>
                        </form>
                    )}
                </AccountSection>
            </div>
        </>
    );
};

export default ChangePassword;
